
<section class="content tab-section d-flex">
    <div class="content-block flex-grow-1">
        <div class=" flex-grow-1 d-flex flex-column">
           <app-document-dashboard class="h-100 d-flex flex-column"></app-document-dashboard>
        </div>
    </div>
</section>